import baseApi from "./baseApi";

const endpoint = "campaign";

export default {
    get: options => {
        let page = options.page != undefined ? options.page : 1;
        let itemsPerPage = options.itemsPerPage != undefined ? options.itemsPerPage : 10;
        let link = endpoint + `?page=${page}&itemsPerPage=${itemsPerPage}`;

        if (options.status != undefined)
            link = link + '&status=' + options.status;

        if (options.search != '')
            link = link + '&search=' + options.search;

        if (options.stopped != null) {
            if (options.stopped === true)
                link = link + '&stopped=true';
        }

        if (options.disabled != null) {
            if (options.disabled === true)
                link = link + '&disabled=true';
        }


        if (options.service != null && options.service != '')
            link = link + '&service=' + options.service;

        return baseApi.get(link);
    },
    show: id => baseApi.show(endpoint, id),
    store: data => baseApi.store(endpoint, data),
    shoot: id => baseApi.store(`${endpoint}/shoot/${id}`, {}),
    update: (id, data) => baseApi.update(endpoint, id, data),
    updateStopped: (id, data) => baseApi.update(`${endpoint}/updateStopped`, id, data),
    reactive: (id) => baseApi.update(`${endpoint}/reactive`, id, {}),
    shoots: id => baseApi.get(`${endpoint}/${id}/shoots`, 0),
    emailsShoot: (id, shoots_id) => baseApi.get(`${endpoint}/${id}/shoots/${shoots_id}/emails`, 0),
    detailEmail: (contact_lists_id, email) => baseApi.store(`${endpoint}/detail-email/${contact_lists_id}`, { to: email }),
    destroy: id => baseApi.destroy(endpoint, id),
};
